import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserRound, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { t, useLanguage } from "@/lib/i18n";
import { publicPath } from "@/lib/seo";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";

export default function HeaderAccount({ className = "" }) {
  const { user, logout } = useAuth();
  const language = useLanguage();
  const navigate = useNavigate();
  const signedIn = user && user.role !== "guest";
  if (user === null) return null;
  if (!signedIn) return <Link to="/login" className={`inline-flex min-h-11 items-center rounded-md px-3 text-sm font-semibold focus-visible:outline focus-visible:outline-2 ${className}`} data-testid="direct-signin-button">{t("Sign in")}</Link>;
  return <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button type="button" className={`inline-flex min-h-11 min-w-11 items-center justify-center rounded-md focus-visible:outline focus-visible:outline-2 ${className}`} aria-label={t("Account settings")} title={t("Account settings")} data-testid="direct-account-button"><UserRound size={20} aria-hidden="true" /></button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="z-[80] max-w-[calc(100vw-24px)]">
      <p className="px-2 py-2 text-sm break-words">{user.name || user.email}</p>
      <DropdownMenuItem className="min-h-11" onSelect={() => navigate("/account")}>{t("Account settings")}</DropdownMenuItem>
      <DropdownMenuItem className="min-h-11" onSelect={() => navigate("/app")}>{t("Open Tree")}</DropdownMenuItem>
      <DropdownMenuItem className="min-h-11" onSelect={async () => { await logout(); navigate(publicPath("/", language)); }} data-testid="direct-signout-button"><LogOut size={18} aria-hidden="true" />{t("Sign out")}</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>;
}
